import React, { useEffect, useState } from "react";
import { Layout, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FetchAgroToolsPageAction, FetchLandingPageAction, FetchProcurementPageAction } from "../../redux/action/LandingPageAction";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { useAuth } from "../../utils/auth/useAuth";
import { LoadingSpinner, CardV2, Button, Icon, Tooltip } from "pepsico-ds";
import "../../components/Layout/Layout.scss";
import CommodityPageHeader from "../../components/Header/CommodityPageHeader";
import AgroPepsicoLogo from '../../assets/AgroPepsicoLogo.svg'
import GlobeAgro from '../../assets/GlobeAgro.svg'
import SproutAgro from '../../assets/SproutAgro.svg'
import GAOLogo from '../../assets/GAO.svg'
import AGROFarming from '../../assets/AGROFarming.svg'
import AgroAppBanner from '../../assets/AgroAppBanner.svg'
import { call7DaysNpsLogic } from "../../utils/utils";
import MainHeader from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import InfoIcon from "../../components/Icons/InfoIcon";
import { getAppLinkAttributes } from "../../utils/fullstory-utils";
import { useTour } from '../../routes/JoyrideProvide'
import { useLoginEffects } from "../WalkmeTour/UseLoginEffects";
const { Content } = Layout;

function AgroTools() {

	const dispatch = useDispatch();
	const { authState } = useAuth();
	const [userInfo, setUserInfo] = useState({});
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [isUserDataFetched, setIsUserDataFetched] = useState(false)

	const [activeIndex, setActiveIndex] = useState(null);

	const { startTour } = useTour();
	
	useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				setUserInfo(user);
				dispatch(FetchLandingPageAction(user));
				setIsUserDataFetched(true)
			}
		}
		setIsDataLoading(true)
		fetchUserInfo();
	}, []);


	const userData = useSelector((state) => state.getLandingPageReducer);

	useLoginEffects(userData)

	const AgroData = useSelector((state) => state.getArgoToolsPageReducer);

	/* istanbul ignore next */
	useEffect(() => {
        if (AgroData && AgroData?.type === "SUCCESS_AGRO_TOOLS_PAGE_ACTION") {
            setIsDataLoading(false)
        
        }
    }, [AgroData])
	
    /* istanbul ignore next */
    useEffect(() => {
		if (isUserDataFetched && userData && userData?.type === "SUCCESS_LANDING_PAGE_ACTION") {
		// dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
		// // 7 days NPS logic
		// const now = Date.now(); // current timestamp in milliseconds

		// const responseDate = new Date(userData?.mostRecentDate).getTime(); // convert to timestamp in ms

		// const diffInMs = Math.abs(now - responseDate); // difference in milliseconds

		// const daysDiff = diffInMs / (1000 * 60 * 60 * 24); // convert ms to days

		// if (daysDiff >= 7) {
		// 	dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
		// } else {
		// 	dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: true }))
		// }

		call7DaysNpsLogic(dispatch, userData)
		setIsDataLoading(true)
		dispatch(FetchAgroToolsPageAction());
		}
		// 7 days NPS logic
    }, [userData])


	useEffect(() => {
			return () => {
				dispatch({ 
					type: 'RESET_AGRO_TOOLS_PAGE_ACTION', 
					payload: "RESET_AGRO_TOOLS_PAGE_ACTION" 
				});
			};
		}, []);

	/* istanbul ignore next */
    // useEffect(()=>{
	// 	console.log("hideTour: ", localStorage.getItem('hideTour'))
	// 	const hideTour = localStorage.getItem('hideTour') === 'true';
	// 	if (userData?.isWalkMeEnabled && !hideTour) {
	// 	startTour();
	// 	}
		
	// },[userData])
    // /* istanbul ignore next */
	//  useEffect(() => {
	// 	const shouldAnimate = sessionStorage.getItem("showLoginAnimation");

	// 	if (shouldAnimate !== "true") return;

	// 	const observer = new MutationObserver(() => {
	// 		const element = document.querySelector(".rocket-wrapper");

	// 		if (element) {
	// 		element.classList.add("animate-blue");

	// 		element.addEventListener(
	// 			"animationend",
	// 			() => {
	// 			element.classList.remove("animate-blue");
	// 			},
	// 			{ once: true }
	// 		);
	// 		sessionStorage.removeItem("showLoginAnimation");
	// 		observer.disconnect(); // stop observing
	// 		}
	// 	});

	// 	observer.observe(document.body, {
	// 		childList: true,
	// 		subtree: true,
	// 	});

	// 	return () => observer.disconnect();
	// }, []);

	if(authState?.isAuthenticated){
		return(
			<>
				<Layout >
					{/* <MainHeader /> */}
					<div style={{ display: "flex" }}>
						{/* <Sidebar /> */}
						<Content style={{ padding: "0 30px 30px 100px", background: "#D7E5F8", minHeight:"125vh" }}>
							{Object.keys(userInfo).length === 0 ? (
								<div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "calc(100vh - 64px)" }}>
									<LoadingSpinner size={{ height: "80px", width: "80px" }} />
								</div>
							) : (
								<>
									{/* <div className="agro-tools-banner">
										<div style={{width: '50%', margin: '50px 30px'}}>
											<div className="agro-tools-header" style={{marginBottom: '15px'}}> AGRO TOOLS </div>
											<div className="agro-tools-subheader">Enterprise platform for agriculture—detect issues early, optimize crop health,<br/> and manage your supply chain with unified analytics and control.</div>
										</div>
										<div style={{marginLeft: 'auto'}}>
											<img src={AGROFarming} alt="icon" />
										</div>
										
									</div> */}
                                    {
                                    	!isUserDataFetched ? (
                                        <>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "calc(100vh - 64px)" }}>
                                                <LoadingSpinner size={{ height: "80px", width: "80px" }} />
                                            </div>
                                        </>
                                    ) : (
                                        <>
											<div style={{}}>
											<CommodityPageHeader header={"AGRO Applications"}
												subtext={"Your AGRO toolkit: where data meets the field 🌾. This page brings together all AGRO applications designed to track, analyze, plan, and farm more sustainably - while maximizing yield and crop quality."}
												image={AgroAppBanner}
												pageName={"AGRO"}
												/>
											
											{  
												(isDataLoading || AgroData?.type == "LOADING_AGRO_TOOLS_PAGE_ACTION") ? 
												<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
													<LoadingSpinner size={{ height: '80px', width: '80px' }} />
												</div>
											:
											<>													

								
											
											<Row gutter={[20, 20]}>
												{AgroData?.courses.map((group, groupIdx) => (
												<Col key={groupIdx} xs={24} sm={24} md={12} lg={6} xl={6}>
													<CardV2
													className="ph-course-card"
													cardBody={{
														isDark: false,
														slot: (
														<div style={{
															minHeight: group[0]?.appCategory.includes("Best Practices") ? "230px" : "443px", width: "100%", height: "100%",
															fontFamily: "Inter"
														}}>
															<div className="agro-card-header">{group[0]?.appCategory}</div>

															<div style={{
															display: "flex", 
															flexWrap: "wrap", gap: 8,
															alignItems: "center", justifyContent: "flex-start",
															marginTop: 16, padding: "0 24px 24px 0", marginLeft: 16
															}}>
															
															{group.map((item, itemIdx) => (
																<>
																	
																	<div style={{display: 'flex', width: '100%', margin: '10px 0 10px 15px', cursor: 'pointer',
																				 backgroundColor: activeIndex === `${item.appCategory}-${item.appName}` ? '#F5F9FF' : ''
																				}} 
																		className="agro-card-individual-app"
																		tabIndex={0}
																		role="button"
																		onKeyDown={(e) => {
																			if (e.key === 'Enter' || e.key === ' ') {
																				setActiveIndex(`${item.appCategory}-${item.appName}`);
																				if (item.appLink) {
																				window.open(item.appLink, "_blank", "noopener")
																				}
																			}
																		}}
																		onClick={() => {
																				
																				setActiveIndex(`${item.appCategory}-${item.appName}`);
																				if (item.appLink) {
																				window.open(item.appLink, "_blank", "noopener")
																				}
																			}}
																			
            															{...getAppLinkAttributes(`${item.appName}`)}
																		>
																		<img src={item.appName == "Global Agro Performance Tracker (GAO KPIs)" ||
																				  item.appName == "FLAG (GAO Website)" ? GAOLogo : 
																				  item.appCategory.includes('CropTrak') ? SproutAgro : 
																				  item.appCategory.includes('Sustainability') ? GlobeAgro : 
																				  AgroPepsicoLogo} alt="icon"
                        														style={{ marginRight: '10px', height: '40px' }}
																		/>
																		 <Button
																			key={`${item.appName}-${itemIdx}`}
																			size="large"
																			variant="tertiary"
																			style={{
																			color: '#004895',
																			fontWeight: 'normal',
																			whiteSpace: 'normal',      // allow wrapping
																			wordBreak: 'break-word',   // break long words
																			overflowWrap: 'anywhere',  // extra safety
																			textAlign: 'left',
																			lineHeight: 1.2,
																			}}
																		>
																			 {item.appName}
																		</Button>
																		{
																			item.appName == "CropTrak" || item.appName == "FLAG (GAO Website)" ? (
																				// <InfoIcon text={'SSO not enabled yet'} direction='top'/>
																				<Tooltip direction="top" 
																					text={"This application is not SSO enabled"}>
																					<Icon alt="" icon="info" size="small" style={{ marginTop: "10px" }}/>
																				</Tooltip>
																			) : <></>
																		}
																		
																		<Button
												
																			key={`${item.appName}-${itemIdx}`}
																			className=""
																			iconTrailing={"open_in_new"}
																			size="large"
																			style={{ color: "#004895", fontWeight: 'normal', marginLeft: 'auto' }}
																			variant="tertiary"
																		/>
																	</div>
																</>
															))}
															</div>
														</div>
														),
														type: "slot",
													}}
													maxScrollHeight="90px"
													state="interactive"
													style={{}}
													type="basic"
													viewport="desktop"
													/>
												</Col>
												))}
											</Row>
											</>
											} 
										</div>
                                        </>
									)}
                                            
                                </>
							)}
						</Content>
					</div>
                    
				</Layout>

									
			</>
		)
	}
}

export default AgroTools;